module.exports = __webpack_public_path__ + "img/como-logo-icon.b1ebd38b.png";